import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import Input from '../../../core/Input';

import { Trash, ArrowLeft } from '../../../../../assets/images/index';

import {
  getEducationsCategory1,
  getEducationsCategory2,
  getEducationsCategory3
} from '../../../../utils/apiDataUserForm';

import {
  StyledLabel,
  LabelBlock,
  StyledBoxInputEducation,
  StyledBoxModuleAlignTop,
  StyledOrderItem,
  StyledIcon
} from './style';

import {
  WrapperCollapsed,
  StyledIconDrop,
  StyledDropdownInputMonths,
  StyledDropdownInputYears,
  RangeDates,
  ItemRangeDates
} from './styleEducation';

import { EDUCATION } from '../../../../constants/literals/modals';

import DropdownInput from '../../../core/DropdownInput';

const EducationItem = ({
  expanded,
  labelStartMonth,
  labelEndMonth,
  labelStartYear,
  labelEndYear,
  listMonths,
  listYears,
  onChangeDegreeInput,
  onChangeCategory1,
  onChangeCategory2,
  onChangeCategory3,
  onChangeSchoolInput,
  onChangeCertificateInput,
  onClickExpand,
  onClickDelete,
  onClickDown,
  onClickUp,
  onSelectStartMonth,
  onSelectStartYear,
  onSelectEndMonth,
  onSelectEndYear,
  order,
  selectedStartMonth,
  selectedEndMonth,
  selectedStartYear,
  selectedEndYear,
  degree,
  school,
  certificateName,
  errorTitle,
  errorCenter,
  formUser,
  categoryId1,
  categoryId2,
  categoryId3
}) => {
  const [categ1, setCateg1] = useState(null);
  const [categ1Name, setCateg1Name] = useState(null);
  const [categ2, setCateg2] = useState(null);
  const [categ2Name, setCateg2Name] = useState(null);
  const [categ3, setCateg3] = useState(null);
  const [categ3Name, setCateg3Name] = useState(null);
  const [idControl, setIdControl] = useState(null);
  const getCategory = (id, cate) => {
    setIdControl(id);
    if (cate === 1) {
      getEducationsCategory2(id).then(data => setCateg2(data));
    } else {
      getEducationsCategory3(id).then(data => setCateg3(data));
    }
  };

  useEffect(() => {
    getEducationsCategory1().then(data => {
      setCateg1(data);
      if (categoryId1) {
        setCateg1Name(data.filter(c1 => c1.id === categoryId1)[0].name);
      }
      if (categoryId2) {
        getEducationsCategory2(categoryId1).then(data => {
          setCateg2(data);
          setCateg2Name(data.filter(c2 => c2.id === categoryId2)[0].name);
        });
      }
      if (categoryId3) {
        getEducationsCategory3(categoryId2).then(data => {
          setCateg3(data);
          setCateg3Name(data.filter(c3 => c3.id === categoryId3)[0].name);
        });
      }
    });
  }, []);

  return (
    <StyledBoxModuleAlignTop className="content-education" tabletSize>
      <StyledOrderItem
        order={order}
        onClickDown={onClickDown}
        onClickUp={onClickUp}
        tabletSize
      />
      <StyledBoxInputEducation tabletSize>
        <StyledIconDrop
          svg={ArrowLeft}
          size="s"
          hover
          onClick={onClickExpand}
          expanded={expanded}
        />
        <StyledLabel>{EDUCATION.TITLE_LABEL}</StyledLabel>
        {formUser ? (
          categ1 && (
            <>
              <DropdownInput
                className="form-dropdown"
                list={categ1}
                label={categ1Name || degree || 'Seleccionar Estudios'}
                onSelect={e => {
                  setCateg2(null);
                  setCateg3(null);
                  setCateg2Name(null);
                  setCateg3Name(null);
                  onChangeCategory1(e);
                  setCateg1Name(e.name);
                  getCategory(e.id, 1);
                }}
              />
              {categ2 && categ2.length > 0 && (
                <>
                  <StyledLabel>
                    {idControl !== 5 ? 'Formación(*)' : 'Rama(*)'}
                  </StyledLabel>
                  <DropdownInput
                    className="form-dropdown"
                    list={categ2}
                    label={
                      categ2Name ||
                      (idControl !== 5 ? 'Formación(*)' : 'Rama(*)')
                    }
                    onSelect={e => {
                      onChangeCategory2(e);
                      setCateg2Name(e.name);
                      getCategory(e.id, 2);
                    }}
                  />
                </>
              )}
              {categ3 && categ3.length > 0 && (
                <>
                  <StyledLabel>Grados(*)</StyledLabel>
                  <DropdownInput
                    className="form-dropdown"
                    list={categ3}
                    label={categ3Name || 'Seleccionar Grado'}
                    onSelect={e => {
                      onChangeCategory3(e);
                      setCateg3Name(e.name);
                    }}
                  />
                </>
              )}
            </>
          )
        ) : (
          <Input
            value={degree}
            onChange={onChangeDegreeInput}
            error={errorTitle}
          />
        )}
        <WrapperCollapsed expanded={expanded}>
          <StyledLabel>
            {categ1Name === 'Otros' ? 'Sugerencia' : EDUCATION.CENTER_LABEL}
          </StyledLabel>
          <Input
            value={school}
            onChange={onChangeSchoolInput}
            error={errorCenter}
          />
          <StyledLabel>{EDUCATION.CERTIFICATE_LABEL}</StyledLabel>
          <Input
            value={certificateName}
            onChange={onChangeCertificateInput}
            error={errorCenter}
          />
          <RangeDates>
            <ItemRangeDates>
              <LabelBlock>{EDUCATION.DATE_FROM_LABEL}</LabelBlock>
              <StyledDropdownInputMonths
                list={listMonths}
                selected={selectedStartMonth}
                label={labelStartMonth}
                onSelect={onSelectStartMonth}
              />
              <StyledDropdownInputYears
                list={listYears}
                label={labelStartYear}
                selected={selectedStartYear}
                onSelect={onSelectStartYear}
              />
            </ItemRangeDates>
            <ItemRangeDates>
              <LabelBlock>{EDUCATION.DATE_UNTIL_LABEL}</LabelBlock>
              <StyledDropdownInputMonths
                list={listMonths}
                selected={selectedEndMonth}
                label={labelEndMonth}
                onSelect={onSelectEndMonth}
              />
              <StyledDropdownInputYears
                list={listYears}
                label={labelEndYear}
                selected={selectedEndYear}
                onSelect={onSelectEndYear}
              />
            </ItemRangeDates>
          </RangeDates>
        </WrapperCollapsed>
      </StyledBoxInputEducation>
      <StyledIcon svg={Trash} hover onClick={onClickDelete} tabletSize />
    </StyledBoxModuleAlignTop>
  );
};

EducationItem.propTypes = {
  expanded: PropTypes.bool,
  labelStartMonth: PropTypes.string,
  labelEndMonth: PropTypes.string,
  labelStartYear: PropTypes.string,
  labelEndYear: PropTypes.string,
  listMonths: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.oneOfType[(PropTypes.string, PropTypes.number)],
      id: PropTypes.oneOfType[(PropTypes.string, PropTypes.number)]
    })
  ).isRequired,
  listYears: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.oneOfType[(PropTypes.string, PropTypes.number)],
      id: PropTypes.oneOfType[(PropTypes.string, PropTypes.number)]
    })
  ).isRequired,
  onChangeDegreeInput: PropTypes.func,
  onChangeSchoolInput: PropTypes.func,
  onChangeCertificateInput: PropTypes.func,
  onChangeCategory1: PropTypes.func,
  onChangeCategory2: PropTypes.func,
  onChangeCategory3: PropTypes.func,
  onClickExpand: PropTypes.func,
  onClickDelete: PropTypes.func,
  onClickDown: PropTypes.func,
  onClickUp: PropTypes.func,
  onSelectStartMonth: PropTypes.func,
  onSelectStartYear: PropTypes.func,
  onSelectEndMonth: PropTypes.func,
  onSelectEndYear: PropTypes.func,
  order: PropTypes.number,
  selectedStartMonth: PropTypes.string,
  selectedEndMonth: PropTypes.string,
  selectedStartYear: PropTypes.string,
  selectedEndYear: PropTypes.string,
  degree: PropTypes.string,
  school: PropTypes.string,
  certificateName: PropTypes.string,
  errorTitle: PropTypes.bool,
  errorCenter: PropTypes.bool,
  formUser: PropTypes.bool
};

EducationItem.defaultProps = {
  expanded: true,
  labelStartMonth: '',
  labelEndMonth: '',
  labelStartYear: '',
  labelEndYear: '',
  errorTitle: false,
  errorCenter: false,
  formUser: false
};

export default EducationItem;
